import classNames from "classnames";
import { useLanguage } from "../../components/contexts/LanguageContext"; // Adicione a importação
import { format } from "date-fns";
import styles from "./footer.module.css";
import logo from "../../assets/images/logo.png";
import translations from '../translations';

const Footer: React.FC = () => {
  const { selectedLanguage } = useLanguage(); 
  
  return (
    <footer className="footer mt-100">
      <div className={classNames("text-center", styles.footer)}>
         {/* <div className={styles.logoContainer}>
                    <a href="#" className="logo">
                        <img src={logo} />
                    </a>

                    <div>
                        <ul className="icon list-unstyled">
                            <li>
                                <a href="#"><i className="fab fa-facebook-f"></i></a>
                            </li>
                            <li>
                                <a href="#">
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M9.49467 6.77491L15.323 0H13.9418L8.88114 5.88256L4.83917 0H0.177246L6.28949 8.89547L0.177246 16H1.55844L6.90267 9.78782L11.1713 16H15.8332L9.49433 6.77491H9.49467ZM7.60293 8.97384L6.98364 8.08805L2.0561 1.03974H4.17754L8.15411 6.72795L8.77341 7.61374L13.9425 15.0075H11.8211L7.60293 8.97418V8.97384Z"
                                            fill="black"
                                        />
                                    </svg>
                                </a>
                            </li>
                            <li>
                                <a href="#"><i className="fab fa-instagram"></i></a>
                            </li>
                            <li>
                                <a href="#"><i className="fab fa-linkedin-in"></i></a>
                            </li>
                        </ul>
                        <ul className="footer-link list-unstyled mb-10">
                            <li><a href="/#home" className="active">Início</a></li>
                            //  <li><a href="/#about">About</a></li> 
                            <li><a href="contact.html">Contactos</a></li>
                        </ul>
                    </div>
                </div> */}
        <div className={styles.copyright}>
          <p className="fw-6 fs-13 copyright m-0 heading-day-string-long">
          {`© `}{format(new Date(), "yyyy")} {translations[selectedLanguage].copyright}
          </p>
        </div>
      </div>
    </footer>
  );
};

export { Footer };
